import React, { useCallback, useContext, useEffect, useState } from 'react';
import { SVGIcon } from '@superops/super-icons';
import { Avatar, Link } from '@superops/ui-design-system';
import HtmlParser from '@nile/mangifera/src/Components/Search/HtmlParser';

function SearchBox(props) {
  const { menulist, selectedModule, tabContext } = props;
  const getModuleName = menulist?.entityType || menulist?.userType;
  const displayData = menulist?.displayData;
  const displayId = displayData?.displayId;
  const clientName = displayData?.client?.name;
  const siteName = displayData?.site?.name;
  const primaryContact = displayData?.primaryContact;
  const address = displayData?.address;
  const requesterOrOwner =
    displayData?.requester?.name || displayData?.owner?.name;
  const primaryText = displayData?.subject || displayData?.name;
  const projectTask = displayData?.project;
  const ticketTask = displayData?.ticket;
  const userEmail = displayData?.email;
  const userPhoneNumber = displayData?.phoneNumber;
  const classId = displayData?.classId;
  const clientContactNumber = displayData?.contactNumber;
  const articleName = menulist?.subject; 
  const articleDescription = menulist?.description; 
  const articleVisibility = menulist?.visibilityType; 
  const moduleObj = [
    {
      module: 'TICKET',
      icon: 'TicketModule',
      id: 'Ticket'
    },
    {
      module: 'TICKETCONVERSATION',
      icon: 'TicketModule',
      id: 'TicketConversation'
    },
    {
      module: 'TICKETNOTE',
      icon: 'TicketModule',
      id: 'TicketNote'
    },
    {
      module: 'CHATCONVERSATION',
      icon: 'TicketModule',
      id: 'ChatConversation'
    },
    {
      module: 'ASSET',
      icon: 'AssetModule',
      id: 'Asset'
    },
    {
      module: 'CLIENT',
      icon: 'ClientModule',
      id: 'Client'
    },
    {
      module: 'SITE',
      icon: 'ClientModule',
      id: 'Site'
    },
    {
      module: 'PROJECT',
      icon: 'ProjectModule',
      id: 'Project'
    },
    {
      module: 'PROJECT',
      icon: 'ProjectModule',
      id: 'ProjectConversation'
    },
    {
      module: 'TASK',
      icon: 'TaskModule',
      id: 'Task'
    },
    {
      module: 'TECHNICIAN',
      icon: 'PrivateArticle',
      id: 'TECHNICIAN'
    },
    {
      module: 'REQUESTER',
      icon: 'AllArticle',
      id: 'REQUESTER'
    }
  ];
  const getIcon = (moduleName) => {
    return moduleObj.filter((obj) => {
      return obj.id === moduleName;
    });
  };
  const imageMap = {
    1: 'WindowsNew',
    2: 'LinuxIcon',
    3: 'MacNew',
    4: 'Printer',
    5: 'Router',
    6: 'Switch',
    7: 'FireWall',
    8: 'UPS',
    9: 'LoadBalancer',
    10: 'PowerDevice',
    11: 'Storage',
    12: 'Wan',
    13: 'WireLessAccessPoint',
    14: 'WirelessLanController',
    15: 'Voip',
    16: 'IpCamera',
    17: 'Storage',
    18: 'ServerHardwareController'
  };



  const iconR = getIcon(getModuleName).map((io) => {
    if (io?.id === 'Asset') {
      return imageMap[classId];
    }
    if (io?.id === 'Site') {
      return 'SiteNew';
    }
    if (io?.id === 'TECHNICIAN' || io?.id === 'REQUESTER') {
      return articleVisibility === 'PUBLIC' ? 'AllArticle' : 'PrivateArticle';
    }
    return io.icon;
  });


  const siteObj = displayData?.clients?.map((el, i) => {
    return el?.sites?.map((elo) => {
      return <p className="secondary-text">{`${el?.name} - ${elo?.name}`}</p>;
    });
  });

  const openAsset = (selectedAsset, el) => {
    switch (selectedAsset?.entityType) {
      case 'User':
        tabContext.current.openTabCb({
          module: 'ASSET_DETAILS',
          data: {
            id: el?.assetId,
            subject: el?.name
          }
        });
        break;
      default:
        break;
    }
  };
  return (
    <div className="sops-searchlist p10">
      <div className="flex">
        <div>
          {selectedModule === 'USER' || menulist?.entityType === 'User' ? (
            <Avatar
              name={primaryText}
              initials={primaryText.slice(0, 1).toUpperCase()}
              size="extraSmall"
            />
          ) : (
            <SVGIcon name={iconR} size="lg" />
          )}
        </div>
        <div className="pl-15">
          <p className="subject-text">
            {displayId && <span className="pr-5">{displayId}</span>}
            <HtmlParser htmlParser={primaryText || articleName} />
          </p>
          <p className="secondary-text">
            {userEmail && (
              <>
                <span className="secondary-text">
                  <HtmlParser htmlParser={userEmail} />
                </span>
                <span className="pl-15">{userPhoneNumber}</span>
              </>
            )}
          </p>
          <p className="secondary-text">
            {requesterOrOwner && (
              <span className="pr5">{requesterOrOwner}</span>
            )}
            {clientName && <span className="pr5">from</span>}
            {clientName && <span className="pr5">{clientName}</span>}
            {siteName && <span className="pr5">{`- ${siteName}`}</span>}
            {primaryContact && (
              <>
                <span>{primaryContact?.name}</span>

                {primaryContact?.phoneNumber !== ' ' ||
                  (primaryContact?.phoneNumber !== null && (
                    <span>{` - ${primaryContact?.phoneNumber}`}</span>
                  ))}
              </>
            )}
            {!!clientContactNumber && (
              <span>{` - ${clientContactNumber}`}</span>
            )}
            {siteObj?.map((el, i) => {
              return el;
            })}

            {displayData?.assets?.map((el, i) => {
              return (
                <p>
                  <Link
                    theme="dark"
                    removeUnderline
                    // onClick={() => openAsset(menulist, el)}
                  >
                    {el?.name}
                  </Link>
                </p>
              );
            })}
          </p>
          {address && (
            <p className="secondary-text">
              <HtmlParser htmlParser={address} />
            </p>
          )}
          {projectTask && (
            <p className="secondary-text flex actr">
              <SVGIcon name="ProjectLogo" color="#908F90" size="sm" />
              <span className="pl5">{`${projectTask?.displayId} - ${projectTask?.name}`}</span>
            </p>
          )}

          {ticketTask && (
            <p className="secondary-text flex actr">
              <SVGIcon name="TicketOutline" color="#908F90" size="sm" />
              <span className="pl5">{`${ticketTask?.displayId} - ${ticketTask?.subject}`}</span>
            </p>
          )}
          {articleDescription && (
            <p className="secondary-text">
              <HtmlParser htmlParser={articleDescription} />
            </p>
          )}

          <p>
            {menulist?.highlightData?.map((el, i) => {
              return (
                <p className="secondary-text">
                  <HtmlParser htmlParser={el?.highlightedVal} />
                </p>
              );
            })}
          </p>
        </div>
      </div>
    </div>
  );
}

export default SearchBox;
